import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import TenantDtl from './TenantDtl';

const TenantDetail = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('View Tenant')} parent={t('Tenant')} title={t('Tenant Detail')} />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <TenantDtl />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default TenantDetail